import React from 'react';
import styled from 'styled-components/macro';
import { Property } from './property-selection/property';
import { useLicensesInReport } from "../utils";
import { DynamicQuarterPeriodTypeSelectionTabs } from "./dynamic-quarter-period-type-selection-tabs";
import { Header } from "./common-styles";

const HeaderControls = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Div = styled.div`
  margin-bottom: 40px;
`;

const List = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-top: 20px;
  max-height: 300px;
  overflow-y: auto;
`;


export function PropertySelection({
  ignoreUnpaidPeriods,
  unpaidPeriodsByLicenseId,
  availablePeriodsById,
  isPaymentPeriodDynamic,
  resetTaxablePeriods,
  disabled,
}) {
  const licenses = useLicensesInReport()

  return (
    <Div>
      <Header>Listed Properties</Header>
      <HeaderControls>
        {isPaymentPeriodDynamic && <DynamicQuarterPeriodTypeSelectionTabs disabled={disabled} resetTaxablePeriods={resetTaxablePeriods}/>}
      </HeaderControls>
      <List>{licenses.map((el) => (
        <Property
          key={el.license}
          {...el}
          unpaidPeriodsByLicenseId={unpaidPeriodsByLicenseId}
          ignoreUnpaidPeriods={ignoreUnpaidPeriods}
          availablePeriodsById={availablePeriodsById}
          disabled={disabled}
        />
      ))}
      </List>
    </Div>
  )
}
